import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tooltip } from '@parchment/atoms';
import { SelectFieldDeprecated } from '../SelectFieldDeprecated/SelectFieldDeprecated';
import TextField from '../TextField/TextField';
export const FieldSet = _ref => {
  let {
    keyType,
    valueType,
    onKeyChange,
    onValueChange,
    keyOptions,
    valueOptions,
    keyItemValue,
    valueItemValue,
    keyPlaceHolder,
    valuePlaceHolder,
    scale,
    onKeyBlur,
    onValueBlur,
    index,
    disableDeselect,
    keyTooltipMessage,
    valueTooltipMessage
  } = _ref;
  const [data, setData] = useState({
    key: keyItemValue,
    value: valueItemValue
  });
  const emptySelect = {
    label: '',
    value: ''
  };
  useEffect(() => {
    setData({
      key: keyItemValue,
      value: valueItemValue
    });
  }, [keyItemValue, valueItemValue]);
  const handleKeyChange = (value, obj) => {
    const newState = {
      ...data
    };
    newState.key = value;
    setData(newState);
    onKeyChange && onKeyChange(obj, newState);
  };
  const handleValueChange = (value, obj) => {
    const newState = {
      ...data
    };
    newState.value = value;
    setData(newState);
    onValueChange && onValueChange(obj, newState);
  };
  const handleOnKeyBlur = (e, value) => {
    onKeyBlur && onKeyBlur(e, value);
  };
  const handleOnValueBlur = (e, value) => {
    onValueBlur && onValueBlur(e, value);
  };
  const getKey = () => {
    switch (keyType) {
      case 'SelectField':
        return /*#__PURE__*/React.createElement(SelectFieldDeprecated, {
          id: `key-select-field-${index}`,
          name: 'key-select-field',
          key: `key-select-field-${index}`,
          required: false,
          options: keyOptions,
          scale: scale,
          value: keyOptions.find(item => item.value === keyItemValue) || emptySelect,
          placeholder: keyPlaceHolder,
          defaultValue: keyItemValue,
          disableDeselect: disableDeselect,
          onChange: option => {
            handleKeyChange(option.value, option);
          },
          onBlur: (e, value) => handleOnKeyBlur(e, value)
        });
      case 'TextField':
        return /*#__PURE__*/React.createElement(TextField, {
          id: `key-text-field-${index}`,
          name: 'key-text-field',
          scale: scale,
          value: keyItemValue,
          placeholder: keyPlaceHolder,
          onChange: val => handleKeyChange(val, val),
          onBlur: e => {
            var _e$target;
            return handleOnKeyBlur(e, e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
          }
        });
    }
  };
  const getValue = () => {
    switch (valueType) {
      case 'SelectField':
        return /*#__PURE__*/React.createElement(SelectFieldDeprecated, {
          id: `value-select-field-${index}`,
          name: 'value-select-field',
          key: `value-select-field-${index}`,
          required: false,
          options: valueOptions,
          scale: scale,
          value: valueOptions.find(item => item.value === valueItemValue) || emptySelect,
          placeholder: valuePlaceHolder,
          defaultValue: valueItemValue,
          disableDeselect: disableDeselect,
          onChange: option => handleValueChange(option.value, option),
          onBlur: (e, value) => handleOnValueBlur(e, value)
        });
      case 'TextField':
        return /*#__PURE__*/React.createElement(TextField, {
          id: `value-text-field-${index}`,
          name: 'value-text-field',
          scale: scale,
          value: valueItemValue,
          placeholder: valuePlaceHolder,
          onBlur: e => {
            var _e$target2;
            return handleOnValueBlur(e, e === null || e === void 0 ? void 0 : (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value);
          },
          onChange: val => handleValueChange(val, val)
        });
    }
  };
  return /*#__PURE__*/React.createElement(FlexDiv, null, /*#__PURE__*/React.createElement(StyleDiv, null, /*#__PURE__*/React.createElement(Tooltip, {
    message: keyTooltipMessage,
    placement: "above",
    context: "info"
  }, getKey())), /*#__PURE__*/React.createElement(StyleDiv, null, /*#__PURE__*/React.createElement(Tooltip, {
    message: valueTooltipMessage,
    placement: "above",
    context: "info"
  }, getValue())));
};
FieldSet.propTypes = {
  scale: PropTypes.string,
  onKeyChange: PropTypes.func,
  onValueChange: PropTypes.func,
  keyType: PropTypes.string,
  valueType: PropTypes.string,
  keyOptions: PropTypes.array,
  valueOptions: PropTypes.array,
  keyPlaceHolder: PropTypes.string,
  valuePlaceHolder: PropTypes.string,
  keyItemValue: PropTypes.string,
  valueItemValue: PropTypes.string,
  onKeyBlur: PropTypes.func,
  onValueBlur: PropTypes.func,
  index: PropTypes.number,
  disableDeselect: PropTypes.bool,
  keyTooltipMessage: PropTypes.string,
  valueTooltipMessage: PropTypes.string
};
FieldSet.defaultProps = {
  scale: 'medium',
  keyValidators: [],
  valueValidators: []
};
const FlexDiv = /*#__PURE__*/styled.div.withConfig({
  displayName: "FieldSet__FlexDiv",
  componentId: "sc-10d0zob-0"
})(["display:flex;justify-content:space-between;"]);
const StyleDiv = /*#__PURE__*/styled.div.withConfig({
  displayName: "FieldSet__StyleDiv",
  componentId: "sc-10d0zob-1"
})(["label{display:none;}width:48%;"]);